import { useSyncExternalStore } from 'react';
import { getLiveState, subscribeLive, type LiveState } from '@/sync/live';

/**
 * Whether this device is in step with the server.
 *
 * `useSyncExternalStore` rather than a store slice: this changes on a timer and
 * on network events, and it is not part of the shop's state.
 */
export function useSync(): LiveState {
  return useSyncExternalStore(subscribeLive, getLiveState, getLiveState);
}
